import { render, staticRenderFns } from "./BlockedCookies.vue?vue&type=template&id=52a8b748&"
import script from "./BlockedCookies.vue?vue&type=script&lang=js&"
export * from "./BlockedCookies.vue?vue&type=script&lang=js&"
import style0 from "./BlockedCookies.vue?vue&type=style&index=0&id=52a8b748&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports